import React, { useMemo } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import PostCard from './PostCard';
import PostEmptyState from './PostEmptyStates';
import { POST_STATUSES } from '../../services/SocialPostService';

export default function PostApprovalList({
  posts = [],
  onEdit,
  onApprove,
  onQueue,
  onCancel,
  onRetry,
  onClick,
  loading = false,
}) {
  const pendingApproval = useMemo(
    () => posts.filter((p) => p.status === POST_STATUSES.pending_approval),
    [posts]
  );
  const failed = useMemo(
    () => posts.filter((p) => p.status === POST_STATUSES.failed),
    [posts]
  );

  if (loading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="animate-pulse h-28 bg-zinc-100 rounded-2xl" />
        ))}
      </div>
    );
  }

  const isEmpty = pendingApproval.length === 0 && failed.length === 0;
  if (isEmpty) {
    return <PostEmptyState type="approval" />;
  }

  return (
    <div className="space-y-8">
      {/* Failed posts at top — needs attention */}
      {failed.length > 0 && (
        <section>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-red-100 text-red-600 flex items-center justify-center">
              <FiAlertTriangle className="w-4 h-4" />
            </div>
            <h3 className="text-sm font-semibold text-red-700">Needs Attention</h3>
            <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-600 text-[11px] font-semibold">
              {failed.length}
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
            {failed.map((post) => (
              <PostCard
                key={post._id}
                post={post}
                onEdit={onEdit}
                onRetry={onRetry}
                onClick={onClick}
              />
            ))}
          </div>
        </section>
      )}

      {/* Pending approval */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <span className="text-xs font-semibold text-zinc-500 uppercase tracking-wider">
            {pendingApproval.length} pending approval
          </span>
        </div>
        {pendingApproval.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {pendingApproval.map((post) => (
              <PostCard
                key={post._id}
                post={post}
                onEdit={onEdit}
                onApprove={onApprove}
                onClick={onClick}
              />
            ))}
          </div>
        ) : (
          <div className="rounded-2xl border-2 border-dashed border-zinc-200 p-8 text-center">
            <p className="text-sm text-zinc-400">Nothing waiting for approval</p>
          </div>
        )}
      </section>
    </div>
  );
}
